const e=(...e)=>{let t=[];for(let n of e)if(n)if(Array.isArray(n))for(let e of n)t.push(e);else t.push(n);return t};export{e as mergeSx};